import { useNewCode } from '@calendly/feature-check-react';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AIAssistantBanner, AI_ASSISTANT_BANNER_DISMISSED_KEY } from 'components/home/ai_assistant_banner';
import { CAF_EMAIL_AGENT_FEATURE } from 'constants/feature_flags';
import { useInvitationRedirect } from 'features/organization_settings';
import { useLocalStorageAlerts } from 'hooks/use_local_storage_alerts';
import { AIEmailAgentBannerDismissedContext } from './ai_email_banner_dismissed';
import { SchedulingPageOnboardingTour, SchedulingTourRefsProvider } from './onboarding_tour';
import { TabContent } from './tab_content';
import { MeetingTypesContentLoader } from './tab_content/meeting_types/content_loader';
import { TabNavigation } from './tab_navigation';
import { UpgradeInformer, UpgradeOverlayWrapper } from './upgrade_informer';
import { MEETING_TYPES_PATH_PREFIX, useMeetingTypesInitialLoad } from './use_meeting_types_initial_load';
const bannerWrapperCss = "bvn605h";
const tabContentWithBannerCss = "t12pq2hy";
const schedulingShellCss = "s1hx3hl4";
const schedulingMainCss = "s1vfp59q";
const schedulingMainHostCss = "sztydrt";
const tabContentHostCss = "toz6kow";
const tabContentHiddenCss = "teuzwyl";
export const Scheduling = () => {
  const {
    pathname
  } = useLocation();
  const isCallieTab = pathname.startsWith('/app/scheduling/callie');
  const isMeetingTypesRoute = pathname.startsWith(MEETING_TYPES_PATH_PREFIX);
  const {
    isContentLoading,
    isColdMeetingTypesLoad
  } = useMeetingTypesInitialLoad();
  const showMeetingTypesLoadOverlay = isMeetingTypesRoute && isContentLoading && !isColdMeetingTypesLoad;
  useInvitationRedirect(isMeetingTypesRoute && isContentLoading && !isColdMeetingTypesLoad);
  const isCafEmailAgentFeatureEnabled = useNewCode(CAF_EMAIL_AGENT_FEATURE)?.enabled;
  const [isBannerDismissed, setIsBannerDismissed] = useState(() => localStorage.getItem(AI_ASSISTANT_BANNER_DISMISSED_KEY) === 'true');
  const contextValue = useMemo(() => ({
    isBannerDismissed,
    isCafEmailAgentFeatureEnabled,
    setIsBannerDismissed
  }), [isBannerDismissed, isCafEmailAgentFeatureEnabled]);
  useLocalStorageAlerts();
  const showAiAssistantBanner = isCafEmailAgentFeatureEnabled && !isBannerDismissed && !isCallieTab;
  return <AIEmailAgentBannerDismissedContext.Provider value={contextValue}>
      <SchedulingTourRefsProvider>
        <div className={schedulingShellCss}>
          <TabNavigation />
          {showAiAssistantBanner && <div className={bannerWrapperCss}>
              <AIAssistantBanner onDismiss={() => setIsBannerDismissed(true)} />
            </div>}
          <UpgradeInformer />
          <UpgradeOverlayWrapper>
            <div className={classNames(schedulingMainCss, schedulingMainHostCss, {
            [tabContentWithBannerCss]: showAiAssistantBanner && !showMeetingTypesLoadOverlay
          })}>
              <div className={classNames(tabContentHostCss, {
              [tabContentHiddenCss]: showMeetingTypesLoadOverlay
            })}>
                <TabContent />
              </div>
              {showMeetingTypesLoadOverlay && <MeetingTypesContentLoader overlay />}
            </div>
          </UpgradeOverlayWrapper>
          <SchedulingPageOnboardingTour />
        </div>
      </SchedulingTourRefsProvider>
    </AIEmailAgentBannerDismissedContext.Provider>;
};

require("./scheduling.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./scheduling.js");